module.exports = __webpack_public_path__ + "img/stock4.c8891af6.png";